import useDebounce from '@UI/Hooks/useDebounce';
import userFiltersSignal, {
	setUserFilters,
} from '@UI/Pages/Administration/Users/Filters/Signals/userFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { InputText } from '@verclam/ui-kit';

const SEARCH_DEBOUNCE_DELAY_IN_MILLISECONDS = 300;

/**
 * Keeps local state for immediate keystroke feedback while the write to the signal is debounced.
 * The local state follows the signal, so an external reset empties the field.
 */
const SearchFilter: React.FC = () => {
	const currentFilters = useSignalValue(userFiltersSignal);
	const [searchInput, setSearchInput] = React.useState(currentFilters.search);
	const debouncedSearch = useDebounce(searchInput, SEARCH_DEBOUNCE_DELAY_IN_MILLISECONDS);

	React.useEffect(() => {
		setSearchInput(currentFilters.search);
	}, [currentFilters.search]);

	React.useEffect(() => {
		if (debouncedSearch === userFiltersSignal.peek().search) {
			return;
		}

		setUserFilters(userFiltersSignal.peek().setSearch(debouncedSearch));
	}, [debouncedSearch]);

	const handleSearchChange = React.useCallback((value: string) => {
		setSearchInput(value);
	}, []);

	return (
		<InputText
			name="userSearch"
			label="Recherche"
			isLabelHidden
			placeholder="Nom, prénom ou courriel"
			value={searchInput}
			onChange={handleSearchChange}
		/>
	);
};

export default SearchFilter;
